import { defineStore, storeToRefs } from "pinia";
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar";
import useCotizacionEstandarDatosStore from "@/store/cotizaciones/estandar/datos";
import useCotizacionEstandarKeyMetricsStore from "@/store/cotizaciones/estandar/key-metrics";

import { computed, ref } from "vue";

const useCotizacionEstandarLeaseParametersStore = defineStore(
  "cotEstLeaseParameters",
  () => {
    const {
      state,
      stateCotizacion,
      tablaTIR,
      stateCalculosLeaseParameters,
    } = storeToRefs(useCotizacionEstandarStore());

    const { precioFinal, tdcInformativo } = storeToRefs(
      useCotizacionEstandarDatosStore()
    );

    const { obtenerDatoPorPlazo } = useCotizacionEstandarDatosStore();

    const leaseParameters = computed(() => {
      if (!tablaTIR.value) return null;
      const blindDisc = 0;
      const rentUpFront = ref(
        stateCotizacion.value[
          `numRentaDeposito_${stateCotizacion.value.plazo}`
        ] * 100
      );
      const equipmentValueBeforeDes = ref(precioFinal.value);
      const equipmentValueBeforeNet = ref(
        equipmentValueBeforeDes.value * (1 - blindDisc)
      );
      const buyOut = ref(
        stateCotizacion.value[`buyOut_${stateCotizacion.value.plazo}`]
      );
      const rvPorcentaje = ref(
        obtenerDatoPorPlazo(stateCotizacion.value.plazo, "residual_calculo")
      );
      const rvMonto = ref(
        equipmentValueBeforeDes.value * (rvPorcentaje.value / 100)
      );
      const coupon = ref(
        obtenerDatoPorPlazo(stateCotizacion.value.plazo, "tasa")
      );
      const couponPorcentaje = ref(coupon.value / 100 / 12);
      const duration = ref(stateCotizacion.value.plazo);
      const downPaymentPorcentaje = ref(
        obtenerDatoPorPlazo(stateCotizacion.value.plazo, "anticipo")
      );
      console.log(
        (downPaymentPorcentaje.value / 100) * equipmentValueBeforeDes.value
      );
      const downPaymentMonto = ref(
        (downPaymentPorcentaje.value / 100) * equipmentValueBeforeDes.value
      );
      const openingFeePorcentaje = ref(
        obtenerDatoPorPlazo(stateCotizacion.value.plazo, "comision")
      );
      const openingFeeMonto = ref(
        (openingFeePorcentaje.value / 100) * equipmentValueBeforeDes.value
      );
      const vatMonto = ref(
        (stateCalculosLeaseParameters.value.vat / 100) *
          equipmentValueBeforeNet.value
      );
      const vatRecoupedAtMonth = ref(duration.value + 1);
      const downPaymentAmtVAT = ref(
        (downPaymentPorcentaje.value / 100) *
          equipmentValueBeforeDes.value *
          (stateCalculosLeaseParameters.value.vat / 100)
      );
      const fx = ref(tdcInformativo.value);
      const monthlyRentDueDate = ref(
        stateCalculosLeaseParameters.value.firstPaymentDate.slice(-2)
      );
      const partialDayInterestRate = ref(coupon.value);
      const openingFeeVAT = ref(openingFeeMonto.value * 1.16);
      /* const monthlyInterestDuringGracePeriod = ref(
        couponPorcentaje.value * keyMetrics.value.leasePrincipalAmount ?? 0
      );
 */
      // LeaseParametersStore  (solo fragmento relevante)
      const leasePrincipalAmount = computed(
        () => equipmentValueBeforeDes.value - downPaymentMonto.value
      );

      const monthlyInterestDuringGracePeriod = computed(
        () => couponPorcentaje.value * leasePrincipalAmount.value
      );

      return {
        blindDisc,
        buyOut,
        coupon,
        couponPorcentaje,
        downPaymentAmtVAT,
        downPaymentMonto,
        downPaymentPorcentaje,
        duration,
        equipmentValueBeforeDes,
        equipmentValueBeforeNet,
        fx,
        monthlyInterestDuringGracePeriod,
        monthlyRentDueDate,
        openingFeeMonto,
        openingFeePorcentaje,
        openingFeeVAT,
        partialDayInterestRate,
        rentUpFront,
        rvMonto,
        rvPorcentaje,
        vatMonto,
        vatRecoupedAtMonth,
      };
    });
    return {
      leaseParameters,
    };
  }
);

export default useCotizacionEstandarLeaseParametersStore;
